import React from "react";
import { Box, Typography, Grid, Chip } from "@mui/material";

const ViewProduct = ({ product }) => {
  if (!product) return null;

  const precioFinal =
    product.iva_porcentaje === 999
      ? Number(product.pvp1).toFixed(2)
      : (Number(product.pvp1) + Number(product.iva_valor || 0)).toFixed(2);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" mb={2}>Detalles del Producto</Typography>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography><strong>Código:</strong> {product.code}</Typography>
          <Typography><strong>Nombre:</strong> {product.name}</Typography>
          <Typography><strong>Código de barras:</strong> {product.barcode || "-"}</Typography>
          <Typography><strong>Código auxiliar:</strong> {product.codigo_auxiliar || "-"}</Typography>
          <Typography><strong>Seriado:</strong> {product.seriado ? "Sí" : "No"}</Typography>
          <Typography><strong>Estado:</strong> {product.estado}</Typography>
          <Box mt={1}>
            <strong>E-commerce:</strong>{" "}
            <Chip
              size="small"
              label={product.ecommerce ? "Visible" : "No visible"}
              color={product.ecommerce ? "success" : "default"}
            />
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Typography><strong>Sección:</strong> {product.section}</Typography>
          <Typography><strong>Categoría:</strong> {product.category}</Typography>
          <Typography><strong>Marca:</strong> {product.brand}</Typography>
          <Typography><strong>Stock:</strong> {product.stock}</Typography>
          <Typography><strong>Stock mínimo:</strong> {product.stock_minimo}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography><strong>PVP1:</strong> {Number(product.pvp1).toFixed(2)}</Typography>
          <Typography>
            <strong>IVA %:</strong>{" "}
            {product.iva_porcentaje === 999
              ? "No objeto de IVA"
              : `${product.iva_porcentaje}%`}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography>
            <strong>IVA $:</strong>{" "}
            {product.iva_valor ? Number(product.iva_valor).toFixed(2) : "0.00"}
          </Typography>
          <Typography><strong>Precio Final:</strong> {precioFinal}</Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography mt={2}><strong>Descripción:</strong></Typography>
          <Typography sx={{ whiteSpace: "pre-line" }}>
            {product.description || "-"}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography mt={3}><strong>Imágenes:</strong></Typography>
          <Grid container spacing={1} mt={1}>
            {(product.images || []).map((img, i) => (
              <Grid item xs={4} key={i}>
                <Box
                  sx={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    overflow: "hidden",
                    borderRadius: 2,
                    border: "1px solid #ddd",
                  }}
                >
                  <img
                    src={img}
                    alt={`img-${i}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViewProduct;
